/*
 *
 * ExpiredSessionModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 24-Sep-2025
*/

import ExpiredSessionModal from './ExpiredSessionModalContainer'

export default ExpiredSessionModal
